import { paymentsCreatePaymentIntent } from "@alliance/shared/client";
import Card, { CardStyle } from "@alliance/shared/ui/Card";
import { Elements } from "@stripe/react-stripe-js";
import { Appearance, loadStripe } from "@stripe/stripe-js";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import "../index.css";

export interface PaymentMethodData {
  stripeId: string;
  last4: string;
}

export interface StripeWrapperContextType {
  token?: string;
  savedPaymentMethod?: PaymentMethodData;
  clientSecret?: string;
  amount?: number;
}

const StripeWrapperContext = createContext<
  StripeWrapperContextType | undefined
>(undefined);

export interface StripeWrapperProps extends React.PropsWithChildren {
  actionId: number;
}

export const StripeWrapper = ({ children, actionId }: StripeWrapperProps) => {
  const [clientSecret, setClientSecret] = useState<string | undefined>();
  const [token, setToken] = useState<string | undefined>();
  const [amount, setAmount] = useState<number | undefined>();
  const [savedPaymentMethod, setSavedPaymentMethod] = useState<
    PaymentMethodData | undefined
  >();

  const stripePromise = loadStripe(
    "pk_test_51RcteKQ3i6almwvvqvNwXcL1mZik72XFgovP6SzDeP7WDVfC0mXXbxpxbJWmY2kGIy5l1SYAQNmyznRfFP5lKt6O00EeWgC6mr"
  );

  console.log("clientSecret", clientSecret);

  useEffect(() => {
    paymentsCreatePaymentIntent({
      body: {
        actionId,
      },
    }).then((res) => {
      if (!res.data?.clientSecret) {
        throw new Error("No client secret");
      }
      setClientSecret(res.data.clientSecret);
      setAmount(res.data.amount);
      if (res.data.userToken) {
        const token: string = res.data.userToken;
        setToken(token);
      }
      if (res.data.savedPaymentMethodId && res.data.savedPaymentMethodLast4) {
        setSavedPaymentMethod({
          stripeId: res.data.savedPaymentMethodId,
          last4: res.data.savedPaymentMethodLast4,
        });
      }
    });
  }, [actionId]);

  const value = useMemo<StripeWrapperContextType>(
    () => ({
      token,
      savedPaymentMethod,
      clientSecret,
      amount,
    }),
    [token, savedPaymentMethod, clientSecret, amount]
  );

  //   if (!clientSecret) {
  //     return (
  //       <Card style={CardStyle.White} className="animate-pulse">
  //         <p>Loading payment</p>
  //       </Card>
  //     );
  //   }

  const appearance: Appearance = {
    theme: "flat",
    variables: {
      logoColor: "dark",
      tabIconColor: "#000",
      borderRadius: "4px",
      fontSizeBase: "15px",
    },
    rules: {
      ".AccordionItem": {
        border: "none",
      },
      ".Input": {
        padding: "8px 12px",
      },
    },
    labels: "floating",
  };

  return clientSecret ? (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance,
      }}
    >
      <StripeWrapperContext.Provider value={value}>
        {children}
      </StripeWrapperContext.Provider>
    </Elements>
  ) : (
    <Card
      style={CardStyle.White}
      className="animate-pulse items-center justify-center"
    >
      <p className="!p-2">Loading payment</p>
    </Card>
  );
};

export const usePaymentIntentData = (): StripeWrapperContextType => {
  const ctx = useContext(StripeWrapperContext);
  if (!ctx) {
    throw new Error(
      "usePaymentIntentData must be used within an StripeWrapper"
    );
  }
  return ctx;
};
